function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "14",
  height: "13",
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M12.376 2.328a.851.851 0 10-1.204-1.204L7 5.296 2.828 1.124a.851.851 0 00-1.204 1.204L5.796 6.5l-4.172 4.172a.851.851 0 101.204 1.204L7 7.704l4.171 4.172a.851.851 0 001.205-1.204L8.204 6.5l4.172-4.172z",
  fill: "#057CCC"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.227.727a1.414 1.414 0 012 0L7 4.5 10.774.727a1.414 1.414 0 112 2L9 6.5l3.773 3.774a1.414 1.414 0 11-2 2L7 8.5l-3.774 3.773a1.414 1.414 0 01-2-2L5 6.5 1.227 2.726a1.414 1.414 0 010-2zm1.204.795a.289.289 0 10-.409.409L6.592 6.5l-4.57 4.57a.289.289 0 00.409.408L7 6.908l4.57 4.57a.289.289 0 10.408-.409L7.408 6.5l4.57-4.57a.289.289 0 10-.409-.408L7 6.092l-4.57-4.57z",
  fill: "#057CCC"
})));